// extracted by mini-css-extract-plugin
export default {"testSearch":"_2vMo7QurMVHTtg7DOFhwvm","text-map":"bGl7hNRS_CxMcvEDZgDzC","col-lg-8":"_3Y-EYnRkbobMcVyuRiJdgu","col-lg-4":"_2UPsIhFNWM3QaV97gxgpJX","toggle":"_1IqMw9kHhpUouwpkQP7Agz"};